/**
 * Bangladesh timezone (UTC+6) date utilities.
 * `new Date().toISOString().slice(0,10)` returns the UTC date,
 * which can be off by one day for users in BD between 00:00–06:00 BDT.
 * These helpers always return the BD-local date/time.
 */

const BD_OFFSET_MINUTES = 6 * 60; // UTC+6

/** Returns today's date in BD timezone as YYYY-MM-DD */
export function getBDDate() {
  const now = new Date();
  const bdTime = new Date(now.getTime() + (BD_OFFSET_MINUTES + now.getTimezoneOffset()) * 60000);
  return bdTime.toISOString().slice(0, 10);
}

/** Returns current BD date+time as YYYY-MM-DD HH:mm:ss */
export function getBDDateTime() {
  const now = new Date();
  const bdTime = new Date(now.getTime() + (BD_OFFSET_MINUTES + now.getTimezoneOffset()) * 60000);
  return bdTime.toISOString().slice(0, 19).replace('T', ' ');
}

/** Formats any date string/Date to BD-local YYYY-MM-DD */
export function toBDDate(date) {
  const d = new Date(date);
  const bdTime = new Date(d.getTime() + (BD_OFFSET_MINUTES + d.getTimezoneOffset()) * 60000);
  return bdTime.toISOString().slice(0, 10);
}
